<template>
  <el-menu id="navClient" :default-active="activeIndex + ''" class="el-menu-vertical-demo" @select="handleselect"  @open="handleOpen" @close="handleClose" :collapse="isCollapse">
    <div style="font-size:15px; font-weight:700; width:100%; display:flex; height:42px;background-color: #F2F6FC; align-items: center; border-bottom:1px solid #ccc;">
      <p style="padding:20px;">导航栏</p></div>
    <template  v-for="item in navMenus">
      <el-submenu :index="item.id + ''" v-if="item.children && item.children.length > 0">
        <template slot="title">
          <i :class="item.menuIcon"></i>
          <span slot="title" style="font-size:13px;">{{item.menuName}}</span>
        </template>
        <el-menu-item v-if="item.children && item.children.length > 0" v-for="itemChild in item.children" :index="itemChild.id + ''" v-on:click="selectItme(itemChild)">
          <i :class="itemChild.menuIcon"></i>
          <span slot="title" style="font-size:13px;">{{itemChild.menuName}}</span>
        </el-menu-item>
        <!-- <el-menu-item-group  v-if="item.children && item.children.length > 1" v-for="itemChild in item.children">
          <el-menu-item :index="itemChild.id + ''" v-on:click="selectItme(itemChild.id, itemChild.menuUrl)">{{itemChild.menuName}}</el-menu-item>
        </el-menu-item-group> -->
      </el-submenu>
      <el-menu-item :index="item.id + ''" v-else>
        <i :class="item.menuIcon"></i>
        <span slot="title" style="font-size:13px;">{{item.menuName}}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: function() {
    return {
      isCollapse: true,
      navMenus: "",
    };
  },
  computed: {
      ...mapState(['activeIndex', 'stateTagsList'])
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleselect: function(a, b) {
      console.log(b);
      //
    },
    selectItme: function(tag) {
      // this.$router.push(url);
      if (this.stateTagsList.length < 15) {
        this.$store.commit('mutationSelectTags', tag)
        this.$router.push(tag.menuUrl)
      }else {
        this.$message({
          message: '无法打开更多，请关闭其他标签！',
          type: 'warning'
        })
      }
    },
    goPAGE() {
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        /*window.location.href="你的手机版地址";*/
      } else {
        /*window.location.href="你的电脑版地址";    */
        this.isCollapse = false;
        this.collapseName = "收缩";
        $("#navClient").width(180);
      }
    },
    getMenuData: function(token) {
      // 初始化默认加载菜单
      this.http.post(
        '/menu/list',
        {
          token: token
        },
        res => {
          if (res.success) {
            // 返回正确的处理
            this.navMenus = res.datas.data;
          } else {
            // 返回错误的处理
            this.message.error(res.message);
          }
        }
      );
    }
  },
  mounted() {
    // 判断手机显示还是pc端显示
    this.goPAGE()
    let token = this.user.getToken()
    console.log('token:' + token)
    this.getMenuData(token)
  }
};
</script>

<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  height: 100%;
}
.el-menu--popup {
  padding: 0px;
}
.el-menu {
  border-right: solid 1px #ccc;
}
.el-menu-item, .el-submenu__title {
  height: 48px;
  line-height: 48px;
}
.app-tag>.el-tabs--top > .el-tabs__content {
  padding-left: 12px!important; 
  font-size: 13px;
  border-left: 1px solid #ccc !important;
}
.el-tag {
  font-size: 13px!important;
}
.el-submenu .el-menu-item {
  height: 42px;
  line-height: 42px;
}
.is-opened> .el-submenu__title {
  border-bottom: 1px solid #EBEEF5;
  border-bottom-color: #EBEEF5!important;
}
.is-opened > .el-menu--inline {
  border-bottom: 1px solid #EBEEF5;
}
.el-submenu__title {
  background-color: var(#f3f3f7, #fff)!important;
  font-weight: 700;
  padding-left: 40px!important;
  font-size: 16px!important;
}
</style>


// WEBPACK FOOTER //
// src/components/common/nav.vue